/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Agent_Hr_DescInputs */

const en_mk_mock_agent_hr_desc = /** @type {(inputs: Mk_Mock_Agent_Hr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job descriptions, announcement drafts, attendance recap.`)
};

const id_mk_mock_agent_hr_desc = /** @type {(inputs: Mk_Mock_Agent_Hr_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobdesc, draf pengumuman, rekap absensi.`)
};

/**
* | output |
* | --- |
* | "Job descriptions, announcement drafts, attendance recap." |
*
* @param {Mk_Mock_Agent_Hr_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_agent_hr_desc = /** @type {((inputs?: Mk_Mock_Agent_Hr_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Agent_Hr_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_agent_hr_desc(inputs)
	return en_mk_mock_agent_hr_desc(inputs)
});